import { useTranslation } from 'react-i18next'

import { Filter, FilterItem } from '@vtex/shoreline'

type WalletShorelineFilterOption = {
  value: string
  label: string
}

type WalletShorelineFilterProps = {
  label: string
  value: string
  onChange: (value: string) => void
  options: WalletShorelineFilterOption[]
}

export const toShorelineFilterValue = (
  selectedValue: string,
  options: WalletShorelineFilterOption[]
) => options.find(option => option.value === selectedValue)?.label || ''

export const fromShorelineFilterValue = (
  selectedLabel: string,
  options: WalletShorelineFilterOption[]
) => options.find(option => option.label === selectedLabel)?.value || ''

export const WalletShorelineFilter = ({
  label,
  value,
  onChange,
  options
}: WalletShorelineFilterProps) => {
  const { t } = useTranslation()

  return (
    <Filter
      label={label}
      value={toShorelineFilterValue(value, options)}
      setValue={next => {
        const currentLabel = toShorelineFilterValue(value, options)
        const resolved = typeof next === 'function' ? next(currentLabel) : next
        const selectedLabel = Array.isArray(resolved)
          ? resolved[0] || ''
          : resolved || ''
        onChange(fromShorelineFilterValue(selectedLabel, options))
      }}
      messages={{
        apply: t('rm:apply'),
        clear: t('rm:clear')
      }}
    >
      {options.map(option => (
        <FilterItem key={option.value} value={option.label}>
          {option.label}
        </FilterItem>
      ))}
    </Filter>
  )
}
